export default __webpack_public_path__ + "static/media/marker-yellow-red.6b6aaa28.png";